<div class="wrapper pt-4">
  <div class="page-wrapper">
    <div class="page-content">
      <div class="row mb-2">
        <div class="col-xl-12">
          <!-- Header -->
          <div class="mb-4">
            <p class="text-muted mb-1">
              {{ currentDate | date : "dd MMM, yyyy" }}
            </p>
            <h2>👋 Hello, {{ userName }}</h2>
            <p class="text-muted">
              Welcome to OUK, your gateway to learning and growth!
            </p>
          </div>

          <!-- Top row -->
          <div class="row g-3 mb-3">
            <!-- My Application -->
            <div class="col-md-6 col-lg-6">
              <div class="card-box">
                <div *ngIf="myApplicationData.length" class="d-flex justify-content-between align-items-center">
                  <h6 class="fw-bold mb-0">
                    My Application
                    <span class="saved-badge">{{
                      myApplicationData[0]?.application_status
                      }}</span>
                  </h6>
                  <button class="btn btn-resume w-25" [routerLink]="['/OneApp/components/oukRegForm']"
                    (click)="storeProgramId()" [disabled]="myApplicationData[0]?.is_submit != 0">
                    Resume Application
                  </button>
                </div>
                <div *ngIf="shortCourseData.length" class="d-flex justify-content-between align-items-center pt-2">
                  <h6 class="fw-bold mb-0">
                    My Short Course
                    <!-- <ng-container *ngFor="let item of shortCourseData"> -->
                    <span class="saved-badge">{{ resumeShortCourse?.COURSE_NAME }}</span>
                    <!-- </ng-container> -->
                  </h6>
                  <button class="btn btn-resume w-25" [routerLink]="['/OneApp/components/pdsRegForm']"
                    (click)="storeShortCourseProgramId()" [disabled]="resumeShortCourse?.SHORTCOURSE_ISSUBMIT != 0">
                    Resume
                  </button>
                </div>
                <p class="text-muted small mb-2">
                  Track your application status
                </p>

                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span><strong>Applying Programme</strong> &nbsp;
                    <a href="javascript:void()">
                      <i class="bi bi-box-arrow-up-right"></i></a></span>
                </div>
                <ng-container *ngFor="let item of myApplicationData">
                  <p class="application-programme">
                    {{ item.course_name }}
                  </p>
                </ng-container>
              </div>
            </div>

            <!-- Key Resources -->
            <div class="col-md-3 col-lg-3">
              <div class="card-box">
                <h6 class="fw-bold mb-2">Key Resources</h6>
                <p class="text-muted small mb-1">Featured resources</p>
                <ul class="list-unstyled mb-0">
                  <li>
                    <a href="javascript:void()" class="link-blue">Admission requirements
                      <i class="bi bi-box-arrow-up-right"></i></a>
                  </li>
                  <li>
                    <a href="javascript:void()" class="link-blue">Course brochures
                      <i class="bi bi-box-arrow-up-right"></i></a>
                  </li>
                  <li>
                    <a href="https://ouk.ac.ke/resource-downloads" target="_blank" class="link-blue">Orientation
                      guides
                      <i class="bi bi-box-arrow-up-right"></i></a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Profile -->
            <div class="col-md-3 col-lg-3">
              <div class="card-box profile-card">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="fw-bold mb-0">Profile</h6>
                  <!-- <a
                      href="/OneApp/registration/profile"
                      class="text-warning small text-decoration-none fw-bold"
                      >Edit &rsaquo;</a
                    > -->
                </div>
                <p class="mb-2 small">Personal Information Snapshot</p>
                <div class="d-flex align-items-center">
                  <img [src]="
                        !userDetails?.result?.upload_4
                          ? '../../assets/images/defaultProfile.png'
                          : url + userDetails?.result?.upload_4
                      " alt="Profile" class="rounded-circle me-2" width="40" height="40" />
                  <div>
                    <div class="fw-bold text-white">{{ userName }}</div>
                    <div class="small text-warning">Applicant</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Second row -->
          <div class="row g-3">
            <!-- My Applications -->
            <div class="col-md-6 col-lg-6">
              <div class="card-box">
                <h6 class="fw-bold">My Applications</h6>
                <p class="text-muted small">
                  Checklist of submitted documents (ID, certificates,
                  transcripts, etc.)
                </p>
                <ul class="list-unstyled">
                  <li *ngFor="let item of table">
                    <strong>{{ item.COURSE_NAME }}</strong>
                  </li>

                  <li class="highlight-orange" *ngFor="let item of myApplicationData">
                    {{ item.course_name }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Documents -->
            <div class="col-md-3 col-lg-3">
              <div class="card-box">
                <h6 class="fw-bold">Documents</h6>
                <p class="text-muted small">
                  <a style="color: black" href="/OneApp/misReports/myDocuments">
                    Checklist of submitted documents (ID, certificates,
                    transcripts, etc.)</a>
                </p>
                <!-- <p class="mb-0">Application Certificate</p> -->
                <p class="text-danger fw-semibold">
                  <a (click)="downloadForm()" [ngClass]="{
                        'disabled-link': isSubmitDisabled(
                          userDetails?.result?.is_submit
                        )
                      }" style="cursor: pointer">Admission letter</a>
                </p>
              </div>
            </div>

            <!-- Communication Center -->
            <div class="col-md-3 col-lg-3">
              <div class="card-box">
                <h6 class="fw-bold">Communication Center</h6>
                <p class="text-muted small">
                  Get updated with the latest news from OUK
                </p>
                <ul class="list-unstyled mb-0">
                  <li>
                    <a href="https://ouk.ac.ke/call-center" target="_blank" class="link-blue">FAQs / Help Desk link
                      <i class="bi bi-box-arrow-up-right"></i></a>
                  </li>
                  <li>
                    <a href="https://ouk.sysaidit.com/servicePortal" target="_blank" class="link-blue">Raise a support
                      ticket
                      <i class="bi bi-box-arrow-up-right"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>